// Resource type categories for filtering cloud resources
export const RESOURCE_TYPE_CATEGORIES: Record<string, string[]> = {
  Compute: [
    'AWS::EC2::Instance', 'AWS::ECS::Cluster', 'AWS::ECS::Service', 'AWS::EKS::Cluster',
    'OCI::Compute::Instance', 'OCI::ContainerEngine::Cluster', 'OCI::ContainerInstances::ContainerInstance',
  ],
  Network: [
    'AWS::EC2::VPC', 'AWS::EC2::Subnet', 'AWS::EC2::SecurityGroup', 'AWS::EC2::NatGateway',
    'AWS::EC2::VPCEndpoint', 'AWS::ElasticLoadBalancingV2::LoadBalancer',
    'OCI::Core::VCN', 'OCI::Core::Subnet', 'OCI::Core::SecurityList', 'OCI::Core::NetworkSecurityGroup',
    'OCI::Core::InternetGateway', 'OCI::Core::NATGateway', 'OCI::Core::ServiceGateway',
    'OCI::LoadBalancer::LoadBalancer',
  ],
  IAM: [
    'AWS::IAM::User', 'AWS::IAM::Role', 'AWS::IAM::Policy',
    'OCI::Identity::User', 'OCI::Identity::Group',
  ],
  Storage: [
    'AWS::S3::Bucket',
    'OCI::ObjectStorage::Bucket',
  ],
  Database: [
    'AWS::RDS::DBInstance', 'AWS::DynamoDB::Table',
    'OCI::Database::AutonomousDatabase', 'OCI::NoSQL::Table',
  ],
  Serverless: [
    'AWS::Lambda::Function',
    'OCI::Functions::Application', 'OCI::Functions::Function',
  ],
};

export const ALL_CATEGORY_NAMES = Object.keys(RESOURCE_TYPE_CATEGORIES);

// Assignable resource types per category — used for ownership selectors.
// For Network, only VPCs/VCNs are selectable; child resources (subnets, SGs, etc.)
// are owned implicitly through the parent VPC.
export const ASSIGNABLE_RESOURCE_TYPES: Record<string, string[]> = {
  ...RESOURCE_TYPE_CATEGORIES,
  Network: ['AWS::EC2::VPC', 'OCI::Core::VCN'],
};

// Network resource types for VPC grouping detection
export const NETWORK_RESOURCE_TYPES = new Set(RESOURCE_TYPE_CATEGORIES.Network);
